import {CatalogCategoryModel} from '../Model/CatalogModel';
import {CatalogTocEntity} from '../Entity/CatalogTocEntity';
import {CatalogCategoryEntity, CatalogCategoryEntityData} from '../Entity/CatalogCategoryEntity';

export const catalogCategoryMapper = (data: CatalogCategoryModel, toc: CatalogTocEntity[]): CatalogCategoryEntity => {
  const catalogCategoryEntityData: CatalogCategoryEntityData = {
    label: data.label,
    page: data.page,
    color: data.color,
    bgColor: data.bgColor,
    items: []
  };

  data.items.map(tocModel => {
    const tocEntity = toc.find(tocItem => tocItem.page === tocModel.page);

    if (tocEntity) {
      catalogCategoryEntityData.items.push(tocEntity);
    }
  });

  return new CatalogCategoryEntity(catalogCategoryEntityData);
};
